import React from 'react'
import Nav from '../Nav/Nav';

import { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { RiAddCircleLine } from "react-icons/ri"
import { EyeIcon } from "@heroicons/react/20/solid";
import axios from "../../api/api"
import ReactPaginate from 'react-paginate';
import { toast } from 'react-toastify'
import { confirmAlert } from 'react-confirm-alert';
import Button from 'react-bootstrap/Button';
import BhajanModel from '../../Modals/BhajanModel';
import { Alert } from 'react-bootstrap';

const GETBYSEARCH_URL = '/api/bhajan/search'
const REMOVEDATA = '/api/bhajan/delete'

function BhajanList() {
  const [page, setPage] = useState('1');
  const [selectrow, setSelectrow] = useState('10');
  const [allbhajan, Setallbhajan] = useState([]);
  const [englishtitle, Setenglishtitle] = useState("")
  const [loading, Setloading] = useState(true)
  const [isupdate, SetisUpdate] = useState('true');
  const [showDetails, setShowDetails] = useState(false);
  const [id, setId] = useState(null);

  document.title = "Bhajan List - Jain Sadhana"




  //////get all data 
  useEffect(() => {
    const getbhajanbysearch = async () => {
      try {

        const bhajanResponse = await axios.get(`${GETBYSEARCH_URL}/?page=${page || ""}&selectrow=${selectrow || ""}&englishtitle=${englishtitle || ""}`)
        Setallbhajan(bhajanResponse?.data)
        Setloading(false)

      } catch (error) {
        console.log(error?.response?.data?.message)
        Setallbhajan([])
        Setloading(false)
      }
    }
    getbhajanbysearch();
  }, [englishtitle, page, selectrow, isupdate])


  //////remove data 

  const removedata = async (id) => {
    try {
      const deletedata = await axios.delete(`${REMOVEDATA}/${id}`)
      SetisUpdate(!isupdate);
      toast.success('Deleted Successfully')

    } catch (error) {
      console.log(error.response.data.message)

    }
  }



  const confirmsubmit = (id) => {

    confirmAlert({
      title: 'Confirm to Delete',
      message: 'Are you sure to delete this...',
      buttons: [
        {
          label: 'Yes',
          onClick: () => removedata(id)
        },
        {
          label: 'No',

        }
      ]
    });
  }


  return (
    <div className="container-fluid mt-3">
      <div className="row me-auto w-100">
        <div className="col-lg-3 px-4">
          <Nav TaskTitleClass="active" bhajan="text-white" />
        </div>
        <div className="col-lg-9">
          <div className='font'>
            <div className='ps-1 company-list-main-section'>


              <div className='container-fluid content-list-main-box' >
                <div className=' position-relative content-box' >
                  <div className='d-flex justify-content-between align-item-center' >
                    <p className='list-page-title text-black' >All Bhajan List </p>
                    <div className="input-group page-input-box">
                      <input type="text" className="form-control search-bar inputC" onChange={(event) => Setenglishtitle(event.target.value)} placeholder="Search Bhajan By Title" aria-label="Username" aria-describedby="basic-addon1" />
                      <span className="input-group-text text-secondary search-button " id="basic-addon1"><i className="fas fa-search me-2"></i></span>
                    </div>

                    <div>
                      <Link to={'/menu/addbhajan'} className='btn button-yellow add-more-btn' > <i className='me-2' ><RiAddCircleLine /></i> Add New Bhajan</Link>
                    </div>
                  </div>
                  {/* table */}
                  <div className='mt-4 tbl' >
                    <table className="table table-bordered user-list-table ">
                      <thead className=' table-head '  >
                        <tr className='bg-yellow ' >
                          <th className=' thead' scope="col">English Title</th>
                          <th className=' thead' scope="col">Hindi Title</th>
                          <th className=' thead' scope="col">Content</th>
                          <th className=' thead' scope="col">Category</th>
                          <th className=' thead' scope="col">Status</th>
                          <th className='thead  align-items-center' scope="col">Action</th>
                        </tr>
                      </thead>
                      {
                        loading === true ? <tr className='fw-bold'>
                          <td className=' text-capitalize text-center dataError' colSpan="4" >Loading Data... please wait!!</td>
                        </tr> : allbhajan?.length === 0 ? <tr className='fw-bold'>
                          <td className=' text-capitalize text-center dataError' colSpan="4" >Data Not Found</td>
                        </tr> :
                          <tbody className='table-body'>
                            {
                              allbhajan?.bhajan?.map((bhajan, i) => {


                                return (

                                  <tr className='fw-bold' key={i}>
                                    <td className='table-data text-capitalize' >{bhajan.englishtitle}</td>
                                    <td className='table-data text-capitalize' >{bhajan.hindititle}</td>
                                    <td className='table-data' >{`${bhajan.content.substring(0, 40)}...........`}</td>
                                    <td className='table-data text-capitalize' >{bhajan?.category?.title}</td>
                                    <td className={`table-data text-capitalize ${bhajan?.status === "published" ? "text-green" : "text-red"}`}>{bhajan?.status}</td>
                                    <td className='table-data d-flex align-items-center ' >
                                      <Button onClick={() => { setShowDetails(true); setId(bhajan?._id) }} className=" btn p-0 text-dark bg-transparent border-0" title="Show Detail">
                                        <EyeIcon width={20} />
                                      </Button>
                                      <Link to={`/menu/editbhajan/${bhajan._id}`} title="Update"><i className="fa-regular fa-pen-to-square icon-size mx-2"></i></Link>

                                      <Link className='mx-2 text-dark' onClick={() => confirmsubmit(bhajan._id)} title="Delete" ><i className="fa-regular fa-trash-can mx-2 icon-size"></i></Link>
                                    </td>

                                  </tr>
                                )
                              })
                            }

                          </tbody>
                      }
                    </table>
                  </div>
                  {/* pagination */}
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={<i className="fa fa-angle-right" title="Next"></i>}
                    onPageChange={(e) => {
                      setPage(e.selected + 1);
                    }}
                    marginPagesDisplayed={2}
                    //pageRangeDisplayed={5}
                    pageCount={allbhajan?.totalPages}
                    previousLabel={<i className="fa fa-angle-left" title="Previous"></i>}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    activeClassName="active"
                    activeLinkClassName="active"
                    disabledClassName="d-none"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <BhajanModel show={showDetails} setShow={setShowDetails} id={id} setId={setId} />
    </div>
  )
}

export default BhajanList